import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { CompanyAttorneyInformationDto, companyAttorneyInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface AttorneyAddEditDialogProps {
  initialValues: CompanyAttorneyInformationDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function AttorneyAddEditDialog({ initialValues, loading, onClose, onSave, open }: AttorneyAddEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={companyAttorneyInformationValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, setFieldValue, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Attorney</DialogTitle>

                  <Grid item xs={12}>
                    <input
                      accept='.png,.jpg,.jpeg'
                      hidden
                      type='file'
                      id='signatureFileInput'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                          setFieldValue('signatureFile', e.target.files[0])
                        }
                      }}
                    />

                    <Button
                      disabled={loading || isSubmitting}
                      onClick={() => {
                        document.getElementById('signatureFileInput')?.click()
                      }}
                      variant='contained'
                    >
                      UPLOAD SIGNATURE
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.signatureFile?.name ?? values.attorneySignatureFileName ?? 'No file uploaded'}
                    </Typography>

                    {errors.signatureFile && (
                      <Typography color='error' variant='body2'>
                        {errors.signatureFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      ||Signature must be uploaded to save.||Image formats accepted: .PNG, .JPG or .JPEG.||The maximum allowed
                      file size for image upload is 20 MB. ||
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
